import { css } from '@emotion/react';

export const paper = css`
  display: flex;
`;

export const content = css``;
